import styled from "styled-components"

export const RattingCommentItemWrapper = styled.div`
    .header{
        .image{
            width: 60px;
            height: 60px;
            border-radius: 50%;
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 50%;
            }
        }
    }
    .header_list{
        position: relative;
    }
    .rating_comment_control{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .modal_ratting{
        min-width: 600px;
    }
    .form_content{
        width: 100%;
        resize: none;
        min-height: 120px;
        outline: none;
    }
    .rating_comment_control_box{
        span{
            display: block;
            text-align: center;
            white-space: nowrap;
            &:hover{
                background-color: #f2f0f0;
            }
        }
    }
    .reply_list{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .reply_item{
        border-left: 4px solid #f2f0f0 ;
    }
`
